export const nonStandardAppointmentNoPatientName = 'No Pet';
export const nonStandardAppointmentNoClientName = 'No Client';
